import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagesInfo, CarouselButtonClick } from '../../../interfaces';
import { SoSvgIconUI } from '../../../so-svg-icon/so-svg-icon.component';

@Component({
  selector: 'so-carousel-message-ui',
  standalone: true,
  imports: [CommonModule, SoSvgIconUI],
  templateUrl: './carousel-message.component.html',
  styleUrl: './carousel-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarouselMessageUI {
  message = input<MessagesInfo | undefined>(undefined);

  buttonClicked = output<CarouselButtonClick>();

  onButtonClick(button: { text: string; url: string; icon?: string }, cardIndex: number): void {
    this.buttonClicked.emit({ button, cardIndex });
  }

  formatIconName(icon: string): string {
    if (!icon) return '';
    // Si ya tiene el prefijo mdi- lo dejamos
    if (icon.startsWith('mdi-')) return icon;
    // Convertir guiones bajos a guiones y agregar prefijo mdi-
    return `mdi-${icon.replace(/_/g, '-')}`;
  }
}
